import React from 'react';
import styled from 'styled-components';
import { Behavior, BodySmallText, FontScale } from '@prisjakt/ui/text/variants';
import { useAppContext } from 'src/components/app-context';
import { layout } from 'src/components/base';
import { MiniCard } from '..';

type RecentProductCollectionMiniCardProps = {
  id: string;
  title: string;
  image?: string | null;
  menu?: React.ReactNode;
  productCount?: number;
  filters?: string[];
  to: string;
  onClick?: () => void;
};

export const CountWrapper = styled.div`
  margin-top: ${layout.measurements.spacing025};
  color: ${({ theme }) => theme.colors.base600};
`;

export const FiltersWrapper = styled.div`
  margin-top: ${layout.measurements.spacing050};
  color: ${({ theme }) => theme.colors.base400};
`;

export const RecentProductCollectionMiniCard: React.FC<
  RecentProductCollectionMiniCardProps
> = props => {
  const { t } = useAppContext();

  return (
    <MiniCard
      title={props.title}
      image={props.image}
      menu={props.menu}
      to={props.to}
      onClick={props.onClick}
    >
      {props.productCount ? (
        <CountWrapper>
          <BodySmallText scale={FontScale.XS} flex="none">
            {t('lists', 'list.n-products', { n: props.productCount })}
          </BodySmallText>
        </CountWrapper>
      ) : undefined}
      {props.filters?.length ? (
        <FiltersWrapper>
          <BodySmallText
            scale={FontScale.XS}
            behavior={Behavior.OnelineEllipsis}
            flex="none"
          >
            {props.filters.join(' • ')}
          </BodySmallText>
        </FiltersWrapper>
      ) : undefined}
    </MiniCard>
  );
};
